import { objectConfigLabels } from '../../../const/design';
import { NodeType } from '../../../types';
import { Case, convertCase } from '../string';

export function getDesignObjectLabel(rawKey: string, nodeType?: NodeType, fallbackToTitle = true) {
  // If the rawKey comes in the form of 'path.path-2.name', we only want the 'name' part.
  const key = rawKey.split('.').pop() ?? rawKey;
  const casedKeys = [key, convertCase(key, Case.snake)];
  const defaultConfig = objectConfigLabels.get('default');
  const config = nodeType && objectConfigLabels.get(nodeType);
  return (
    casedKeys.reduce((label: string | undefined, casedKey) => {
      return label ?? (config && config?.get(casedKey)) ?? defaultConfig?.get(casedKey);
    }, undefined) ?? (fallbackToTitle ? convertCase(key, Case.title) : key)
  );
}
